import React, { useEffect, useRef } from 'react';

interface AdsterraBanner320x50Props {
  className?: string;
  showLabel?: boolean;
}

export const AdsterraBanner320x50: React.FC<AdsterraBanner320x50Props> = ({
  className = '',
  showLabel = true,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Check if iframe already exists
    if (container.querySelector('iframe')) return;

    const iframe = document.createElement('iframe');
    iframe.width = '320';
    iframe.height = '50';
    iframe.title = 'Sponsored Advertisement';
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('frameBorder', '0');
    iframe.style.border = '0';
    iframe.style.overflow = 'hidden';
    iframe.style.display = 'block';

    container.appendChild(iframe);

    try {
      const doc = iframe.contentWindow?.document || iframe.contentDocument;
      if (doc) {
        doc.open();
        doc.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <base target="_blank">
              <style>
                * { margin: 0; padding: 0; box-sizing: border-box; }
                body { margin: 0; padding: 0; display: flex; justify-content: center; align-items: center; overflow: hidden; background: transparent; }
              </style>
            </head>
            <body>
              <script type="text/javascript">
                atOptions = {
                  'key' : 'f256121a40ad8382ea067e5e9e4d1101',
                  'format' : 'iframe',
                  'height' : 50,
                  'width' : 320,
                  'params' : {}
                };
              </script>
              <script type="text/javascript" src="https://www.highrevenueformat.com/f256121a40ad8382ea067e5e9e4d1101/invoke.js"></script>
            </body>
          </html>
        `);
        doc.close();
      }
    } catch (e) {
      console.error('Error rendering Adsterra 320x50 banner:', e);
    }

    return () => {
      if (container && container.contains(iframe)) {
        container.removeChild(iframe);
      }
    };
  }, []);

  return (
    <aside
      aria-label="Advertisement"
      className={`flex flex-col items-center justify-center my-4 overflow-hidden ${className}`}
    >
      {showLabel && (
        <span className="text-[10px] tracking-wider uppercase text-muted-foreground/70 font-semibold mb-1 select-none">
          Advertisement
        </span>
      )}
      <div
        ref={containerRef}
        className="w-[320px] min-w-[320px] h-[50px] min-h-[50px] bg-slate-50/80 rounded-md border border-slate-200/60 shadow-xs flex items-center justify-center overflow-hidden"
      />
    </aside>
  );
};

export default AdsterraBanner320x50;
